import Rectangle = createjs.Rectangle;

createjs.Shape.prototype.updateBounds = function() : void {
    let bounds : Rectangle = this.getBounds();
    if( !bounds ) {
        bounds = new Rectangle(0,0,0,0);
    }
    let graphicBounds : Rectangle = this.graphics.bounds;
    this.setBounds( bounds.x, bounds.y, Math.max(bounds.width, graphicBounds.width), Math.max( bounds.height, graphicBounds.height ) );
};